import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { customerService } from '@services/api/customerService';
import { CustomerSearch } from '@components/customers/CustomerSearch';
import { CustomerTable } from '@components/customers/CustomerTable';
import type { CustomerSearchFilters } from '@/types/customer';
import './CustomerList.css';

export const CustomerList = () => {
  const [searchParams] = useSearchParams();
  const [customers, setCustomers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    // Load initial search from URL params
    const searchQuery = searchParams.get('search');
    if (searchQuery) {
      handleSearch(searchQuery);
    }
  }, []);

  const handleSearch = async (query: string, filters?: CustomerSearchFilters) => {
    setLoading(true);
    
    const result = await customerService.searchCustomers(query, filters);
    
    if (result.success && result.data) {
      setCustomers(result.data);
      setTotalCount(result.count || result.data.length);
    }
    
    setLoading(false);
  };

  return (
    <div className="customer-list">
      <div className="customer-list-header">
        <div>
          <h1 className="page-title">Customers</h1>
          <p className="page-subtitle">
            {totalCount > 0 ? `${totalCount} customers found` : 'Search for customers'}
          </p>
        </div>
      </div>

      <CustomerSearch onSearch={handleSearch} loading={loading} />
      <CustomerTable customers={customers} loading={loading} />
    </div>
  );
};

